import { request2 } from "./request.js";
export function QuestionnairePageList(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/QuestionnairePageList",
    method: "get",
    params: obj,
  });
}
// 添加
export function CreateQuestionnaire(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/CreateQuestionnaire",
    method: "post",
    data: obj,
  });
}
// 编辑
export function EditQuestionnaire(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/EditQuestionnaire",
    method: "post",
    data: obj,
  });
}
// 详情
export function QuestionnaireDetail(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/QuestionnaireDetail",
    method: "get",
    params: {
      id
    },
  });
}
// 删除
export function DelQuestionnaire(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/DelQuestionnaire",
    method: "get",
    params: {
      id
    },
  });
}
// 针对学生合集
export function GetQuestionnaireStudent(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireStudent",
    method: "get",
    params: obj,
  });
}
// 针对学生合集
export function GetQuestionnaireStateList() {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireStateList",
    method: "get",
  });
}
// 针对学生合集
export function QuestionnaireResult(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/QuestionnaireResult",
    method: "get",
    params: {
      id: id
    }
  });
}
export function SendWxMsgQuestionnaire(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/SendWxMsgQuestionnaire",
    method: "post",
    params: {
      id: id
    }
  });
}
export function GetSubjectAndSelectList(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/SubjectAdmin/GetSubjectAndSelectList",
    method: "post",
    data: id
  });
}

export function GetQuestionnaireStudentDtoList(questionnaireId) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireStudentDtoList",
    method: "get",
    params: questionnaireId
  });
}
// 获取评阅详情
export function GetQuestionnaireStudentAnswerDto(questionnaireId) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireStudentAnswerDto",
    method: "get",
    params: {
      questionnaireStudentId: questionnaireId
    }
  });
}
// 提交评阅
export function CheckQuestionnaireStudent(obj) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/CheckQuestionnaireStudent",
    method: "post",
    data: obj
  });
}
// 获取问卷考评指标
export function GetQuestionnaireScoreResult(params) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireScoreResult",
    method: "get",
    params: params
  });
}
// 问卷设置自定义考评指标
export function SetQuestionnaireScoreResult(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/SetQuestionnaireScoreResult",
    method: "post",
    data: data
  });
}
// 查看问卷指标统计
export function GetQuestionnaireScoreResultInfo(id) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/GetQuestionnaireScoreResultInfo",
    method: "get",
    params: {
      questionnaireId:id
    }
  });
}
// 删除学员
export function DelQuestionnaireStudent(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/DelQuestionnaireStudent",
    method: "post",
    params: data
  });
}
// 添加学员
export function AddQuestionnaireStudent(data) {
  return request2({
    url: "/api2/TZsbAdminProductApi/Questionnaire/AddQuestionnaireStudent",
    method: "post",
    params: data
  });
}
